<template>
    <!-- <v-app> -->
    <v-container fluid id="home" class="fill-height" >
        <v-snackbar
        v-model="snackbarVerify"
        :vertical="vertical"
        color="red"
        :timeout="10000" top
        >
        {{ text }}
        <v-btn
            color="white"
            text
            @click="snackbarVerify = false"
        >
            Close
        </v-btn>
        </v-snackbar>
        <v-snackbar v-model="snackbar" :timeout="10000" top :color="color">
            <span>{{message}}</span> 
            <v-btn text color="white" @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-dialog v-model="dialog" max-width="500" persistent>
            <v-card class="pa-7" color="#e0e0e0" >
                <v-card-text class="text-center">
                    <v-avatar color="white" size="90" class="mt-n3">
                        <v-icon color="green" x-large>mdi-check-bold</v-icon>
                    </v-avatar>
                </v-card-text>
                <v-card-text class="text-center black--text">{{message}}</v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn to="/login">Login</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-row justify-center align="center" justify="center">
            <v-col cols="12" sm="12" md="8" >
                <v-card flat>
                    <v-row justify="center">
                        <v-col cols="12" md="3" sm="6">
                            <h3 class="text-center grey--text">LEVEL</h3>
                            <v-card-text class="text-center black--text font-weight-bold">{{profile.level}}</v-card-text>
                        </v-col>
                        <v-col cols="12" md="3" sm="6">
                            <h3 class="text-center grey--text">TOTAL SAVED</h3>
                            <v-card-text class="text-center green--text font-weight-bold">${{profile.totalSaved}}</v-card-text>
                        </v-col>
                        <v-col cols="12" md="3" sm="6">
                            <h3 class="text-center grey--text">TRANSACTIONS</h3> 
                            <v-card-text class="text-center green--text font-weight-bold" v-if="profile.noOfTransactions!==null">{{profile.noOfTransactions}}</v-card-text>
                            <v-card-text class="text-center green--text font-weight-bold" v-if="profile.noOfTransactions===null">0</v-card-text>
                        </v-col>
                        <v-col cols="12" md="3" sm="6">
                            <h3 class="text-center grey--text">RATING</h3>
                            <v-card-text class="text-center"> 
                                <v-rating v-model="profile.ratings" small color="orange" class="pa-0 ma-0" readonly dense></v-rating>
                            </v-card-text>
                        </v-col>
                        
                    </v-row>
                    <!-- <v-row>
                        <v-col cols="12" md="3" sm="6">
                            <v-card-text class="text-center">Level</v-card-text>
                        </v-col>
                         <v-col cols="12" md="3" sm="6">
                            <v-card-text class="text-center">Level</v-card-text>
                        </v-col>
                         <v-col cols="12" md="3" sm="6">
                            <v-card-text class="text-center">Level</v-card-text>
                        </v-col>
                         <v-col cols="12" md="3" sm="6">
                            <v-card-text class="text-center">Level</v-card-text>
                        </v-col>
                        
                    </v-row> -->
                </v-card>
            </v-col>
        </v-row>
        <v-row justify-center align="center" justify="center">
            <v-col cols="12" sm="12" md="7">
                <v-card class="mt-n2" flat>
                    <v-card-text>
                        <v-form ref="form">
                            
                            <v-row no-gutters>
                                <v-col cols="12" md="3" sm="3">
                                    <h4 class="text-right mr-2 black--text hidden-sm-and-down">USERNAME</h4>
                                    <h4 class="text-left mr-2 black--text hidden-md-and-up">USERNAME</h4>
                                </v-col>
                                <v-col cols="12" md="9" sm="9"  >
                                    <v-text-field outlined flat  name="username" v-model="username" type="text" color="grey" dense :rules="usernameRules"></v-text-field>

                                </v-col>
                            </v-row>
                            <v-row no-gutters>
                                <v-col cols="12" md="3" sm="3">
                                    <h4 class="text-right mr-2 black--text hidden-sm-and-down">Email</h4>
                                    <h4 class="text-left mr-2 black--text hidden-md-and-up">Email</h4>
                                
                                </v-col>
                                <v-col cols="12" md="9" sm="9"  >
                                    <v-text-field outlined flat name="email" v-model="email" type="email" color="grey" dense :rules="emailRules"></v-text-field>

                                </v-col>
                            </v-row>
                             <v-row no-gutters>
                                <v-col cols="12" md="3" sm="3">
                                </v-col>
                                <v-col cols="12" md="9" sm="9"  >
                                    <v-card-text class="text-center mt-n4">
                                        <v-btn color="blue" dark large style="width:80%" @click="changeEmail()" :loading="loading">CHANGE EMAIL</v-btn>
                                    </v-card-text>
                                </v-col>
                            </v-row>
                        </v-form>
                        <v-form ref="form2">
                            <v-row no-gutters>
                                <v-col cols="12" md="3" sm="3">
                                    <h4 class="text-right mr-2 black--text hidden-sm-and-down">CURRENT PASSWORD</h4>
                                    <h4 class="text-left mr-2 black--text hidden-md-and-up">CURRENT PASSWORD</h4>
                                
                                </v-col>
                                <v-col cols="12" md="9" sm="9"  >
                                    <v-text-field color="grey" outlined dense name="currentPassword" v-model="currentPassword"
                                        :append-icon="show2 ? 'visibility' : 'visibility_off'"
                                        :type="show2 ? 'text' : 'password'"
                                        @click:append="show2 = !show2"
                                        :rules="currentPasswordRules"
                                        > 
                                    </v-text-field>
                                </v-col>
                            </v-row>
                            <v-row no-gutters>
                                <v-col cols="12" md="3" sm="3">
                                    <h4 class="text-right mr-2 black--text hidden-sm-and-down">NEW PASSWORD</h4>
                                    <h4 class="text-left mr-2 black--text hidden-md-and-up">NEW PASSWORD</h4>
                                
                                </v-col>
                                <v-col cols="12" md="9" sm="9"  >
                                    <v-text-field color="grey" outlined dense name="newPassword" v-model="newPassword"
                                        :append-icon="show1 ? 'visibility' : 'visibility_off'"
                                        :type="show1 ? 'text' : 'password'"
                                        @click:append="show1 = !show1"
                                       :rules="newPasswordRules"
                                        >
                                    </v-text-field>
                                </v-col>
                            </v-row>
                            <v-row no-gutters>
                                <v-col cols="12" md="3" sm="3">
                                </v-col>
                                <v-col cols="12" md="9" sm="9"  >
                                    <v-card-text class="text-center mt-n4">
                                        <v-btn color="blue" dark large style="width:80%" :loading="load" @click="changePassword()">CHANGE PASSWORD</v-btn>
                                    </v-card-text>
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-card-text>
                    <h2 class="text-center black--text">Email Two-Factor Authentication</h2>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="green" dark :loading="loading" class="font-weight-bold title ma-2"  style="width:30%" @click="twoFa('enable')" v-if="profile.twoFactor===0">
                            ENABLE
                        </v-btn>
                        <v-btn color="green" class="font-weight-bold title ma-2"  style="width:30%" disabled @click="twoFa('enable')" v-if="profile.twoFactor===1">
                            ENABLE
                        </v-btn>
                        <v-btn color="red" dark :loading="loading" class="font-weight-bold title ma-2" style="width:30%" @click="twoFa('disable')" v-if="profile.twoFactor===1">
                             DISABLE
                        </v-btn>
                        <v-btn color="red"  class="font-weight-bold title ma-2" style="width:30%" disabled @click="twoFa('disable')" v-if="profile.twoFactor===0">
                             DISABLE
                        </v-btn>
                        <v-spacer></v-spacer>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
    <!-- </v-app> -->
</template>
<script>
export default {
    name:'Login',
    data(){
        return{
           rate:"3",
           show1:false,
           show2:false,
           snackbarVerify:false,
           text: 'Your account has not been verified! Check your mail for verification link',
            vertical: true,
            username:'',
            email:'',
            emailRules:[v => !!v || 'Email is required',
                    v => /.+@.+/.test(v) || 'E-mail must be valid',
            ],
            usernameRules:[v => !!v || 'Username is required'],
            loading:false,
            load:false,
            snackbar:false,
            message:'',
            color:'',
            currentPassword:'',
            newPassword:'',
            currentPasswordRules:[v => !!v || 'Current Password is required'],
            newPasswordRules: [v => !!v || 'New Password is required',
                v => v.length > 5 || 'New Password must not be less than 6 characters'
            ],
            dialog:false,
            type:null
        }
    },
    methods:{
       changeEmail(){
           if (this.$refs.form.validate()){
               this.loading=true
               this.$store.dispatch("ChangeEmail", {
                    "username": this.username,
                    "email": this.email
                })
                .then(()=>{
                    this.loading = false
                    this.message = 'Email Successfully Changed'
                    this.color = 'green'
                    this.snackbar = true
                    this.dialog = true
                    this.username=''
                    this.email = ''
                    this.usernameRules=[]
                    this.emailRules=[]
                })
                .catch((error)=>{
                   this.loading = false
                   let msg = error.response.data.message
                    this.message=msg.toUpperCase()
                    this.color = 'red',
                    this.snackbar = true
                });
           }
       },
        changePassword(){
            if (this.$refs.form2.validate()){
                this.load=true
                this.$store.dispatch("ChangePassword", {
                    "currentPassword": this.currentPassword,
                    "newPassword": this.newPassword
                })
                .then(()=>{
                    this.load = false
                    this.message = 'Password Successfully Changed'
                    this.color = 'green'
                    this.snackbar = true
                    this.dialog = true
                    this.currentPassword=''
                    this.newPassword = ''
                    this.currentPasswordRules=[]
                    this.newPasswordRules=[]
                })
                .catch((error)=>{
                    this.load = false
                    let msg = error.response.data.message
                    this.message=msg.toUpperCase()
                    this.color = 'red',
                    this.snackbar = true
                });
            }
        },
        twoFa(text){
            this.loading=true
            if(text==='enable'){this.type=true}else{this.type=false}
            this.$store.dispatch("TwoFactorAuth", this.type)
            .then(()=>{
                this.$store.dispatch("GetUser", this.$store.state.auth.logindetails.id)
                this.loading = false
                if(text==='enable'){
                    this.message = 'Two Factor Authentication Enabled'
                }else{
                    this.message = 'Two Factor Authentication Disabled'
                }
                this.color = 'green'
                this.snackbar = true
                
            })
            .catch((error)=>{
                this.loading = false
                let msg = error.response.data.message
                this.message=msg.toUpperCase()
                this.color = 'red',
                this.snackbar = true
            });
        }

    },
    created(){
        const userLogged= this.$store.state.auth.isUserLogged
        const userVerified = this.$store.state.auth.logindetails.isVerified
        if(userLogged===true&&userVerified===0){
            this.snackbarVerify=true
        }
    },
    computed:{
        profile(){
            return this.$store.state.auth.logindetails
        }
    }
}
</script>
<style  scoped>
   
</style>